var map = {
	"./applogo.jpg": [
		7925
	],
	"./copy.png": [
		6570
	],
	"./left.jpg": [
		8736
	],
	"./logo-old.png": [
		7124,
		124
	],
	"./logo.png": [
		9363,
		363
	],
	"./q_streak.png": [
		2402
	],
	"./right.jpg": [
		3361
	],
	"./rocket.png": [
		8796
	],
	"./shopping.svg": [
		5924,
		924
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9810;
module.exports = webpackAsyncContext;